<!-- =========================================================================================
  File Name: InstituteAdd.vue
  Description: Institute Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-institute-add">

    <vx-card title="학원 상세 정보" class="mb-base" >
      <institute-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import InstituteAddForm  from './InstituteAddForm'

export default {
  components: {
    InstituteAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
}

</script>
